import { makeGraphqlRequestCloud } from 'api/graphql/graphQLClient';
import { GetCalibrationLevelForStandard } from '@/graphql/cloud/calibration/queries/CalibrationLevelByStandardId.graphql';
import { subscribe } from '@/api/graphql/wsHasuraClient';
import { SelectedCalibrationPointByPeakIds } from '@/graphql/cloud/calibration/subscriptions/SelectedCalibrationPointByPeakIds.graphql';

export const apiCalibrations = {
  async getCalibrationLevelByStandardId(standardId) {
    const { calibration_level: calibrationLevels } = await makeGraphqlRequestCloud(
      GetCalibrationLevelForStandard,
      {
        standardId,
      },
    );
    return calibrationLevels?.[0] ?? null;
  },

  subscribeForSelectedPeakByPeakIds(peakIds, onSelectedPeakId) {
    return subscribe(SelectedCalibrationPointByPeakIds, { peakIds }, ({ calibration_point }) => {
      const selectedPeakId = calibration_point?.[0]?.peak_id ?? null;
      onSelectedPeakId(selectedPeakId);
    });
  },
};
